import React, { useEffect, useState } from 'react';
import GameBoard from 'containers/gameboard/GameBoard';
import { Provider, rootStore, persistenceService } from 'stores/rootStore';
import { PortalProvider } from 'components/portal';
import styles from './App.css';

const App: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const initializeApp = async () => {
            try {
                await persistenceService.loadState();
                console.log('State loaded');
            } catch (error) {
                console.error('Failed to load state:', error);
            } finally {
                setIsLoading(false);
            }
        };

        initializeApp();
    }, []);

    if (isLoading) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.spinner}></div>
            </div>
        );
    }

    return (
        <Provider value={rootStore}>
            <PortalProvider>
                <div className={styles.container}>
                    <GameBoard />
                </div>
            </PortalProvider>
        </Provider>
    );
};

export default App;
